import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import PlayerService from 'services/PlayerService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    playerData: [],
    singlePlayer:[],
    playerTracker:[],
    playerInjuryTracker:[],
    playerGroup: [],
    playerSession: [],
    playerCoach: [],
    
}


export const getPlayer = createAsyncThunk('player/getPlayer', async (params, { rejectWithValue }) => {
	
	try {
		const response = await PlayerService.getPlayer(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const getPlayerWithId = createAsyncThunk('player/getPlayerWithId', async (params, { rejectWithValue }) => {
	
	try {
		const response = await PlayerService.getPlayerWithId(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getPlayerTracker = createAsyncThunk('player/getPlayerTracker', async (params, { rejectWithValue }) => {
	
	try {
		const response = await PlayerService.getPlayerTracker(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getPlayerGroup = createAsyncThunk('player/getPlayerGroup', async (params, { rejectWithValue }) => {
	
	try {
		const response = await PlayerService.getPlayerGroup(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getPlayerInjuryTracker = createAsyncThunk('player/getPlayerInjuryTracker', async (params, { rejectWithValue }) => {
	
	try {
		const response = await PlayerService.getPlayerInjuryTracker(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getPlayerSession = createAsyncThunk('player/getPlayerSession', async (params, { rejectWithValue }) => {
	
	try {
		const response = await PlayerService.getPlayerSession(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getPlayerCoach = createAsyncThunk('player/getPlayerCoach', async (params, { rejectWithValue }) => {
	
	try {
		const response = await PlayerService.getPlayerCoach(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const playerSlice = createSlice({
    name: 'player',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getPlayer.pending, (state) => {
            state.loading = true
        })
        .addCase(getPlayer.fulfilled, (state, action) => {
            state.loading = false
            state.playerData = action.payload
        })
        .addCase(getPlayer.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
        .addCase(getPlayerWithId.pending, (state) => {
            state.loading = true
        })
        .addCase(getPlayerWithId.fulfilled, (state, action) => {
            state.loading = false
            state.singlePlayer = action.payload
        })
        .addCase(getPlayerWithId.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getPlayerTracker.pending, (state) => {
            state.loading = true
        })
        .addCase(getPlayerTracker.fulfilled, (state, action) => {
            state.loading = false
            state.playerTracker = action.payload
        })
        .addCase(getPlayerTracker.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getPlayerInjuryTracker.pending, (state) => {
            state.loading = true
        })
        .addCase(getPlayerInjuryTracker.fulfilled, (state, action) => {
            state.loading = false
            state.playerInjuryTracker = action.payload
        })
        .addCase(getPlayerInjuryTracker.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getPlayerGroup.pending, (state) => {
            state.loading = true
        })
        .addCase(getPlayerGroup.fulfilled, (state, action) => {
            state.loading = false
            state.playerGroup = action.payload
        })
        .addCase(getPlayerGroup.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getPlayerSession.pending, (state) => {
            state.loading = true
        })
        .addCase(getPlayerSession.fulfilled, (state, action) => {
            state.loading = false
            state.playerSession = action.payload
        })
        .addCase(getPlayerSession.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getPlayerCoach.pending, (state) => {
            state.loading = true
        })
        .addCase(getPlayerCoach.fulfilled, (state, action) => {
            state.loading = false
            state.playerCoach = action.payload
        })
        .addCase(getPlayerCoach.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
    }
});


export default playerSlice.reducer;